import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class UploadExcel extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            mvalue: {year: new Date().getFullYear(), month: 11},
            fileType:'Base and EMI',
            _notificationSystem: null,
            loading:false,
            isSubmit:false
        };
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }
    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    onChangeHandler=event=>{
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
         if(ext=='xlsx' || ext=='xls') {
             this.setState({
                 selectedFile: file
             });
         } else{
             this.handleNotificationClick("tr", 3, "Please upload valid file");
             this.setState({
                 selectedFile: file
             });
         }

    };
    fileUploadHandler = () => {
        if(this.state.selectedFile===null) {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            return false;
        }
        this.setState({
            isSubmit:true,
            loading:true
        });
        var monthly = this.state.mvalue;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('fileType', this.state.fileType);
        data.append('for_month', monthly.month+''+monthly.year);
        data.append('userID', decoded.email);
        var file = this.state.selectedFile; //console.log(data);
        var ext = this.getFileExtension(file.name);
        if(ext=='xlsx' || ext=='xls') {
            axios.post(config.get('API_URL')+"/invoice/upload/", data,{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log(res);
                    if(res.data.success){
                        this.handleNotificationClick("tr", 1, res.data.success);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    } else {
                        this.handleNotificationClick("tr", 3, res.data.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    }
                })
                .catch(err => { // then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                })
        }
        else{
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit:false,
                loading:false
            })
        }
    };
    // validateSize=(event)=>{
    //     let file = event.target.files[0];
    //     let size = 30000;
    //     let err = '';
    //     console.log(file);
    //     console.log(file.size);
    //     if (file.size > size) {
    //         err = file.type+'is too large, please pick a smaller file\n';
    //         //toast.error(err);
    //         alert(err);
    //     }
    //     return true
    // };
    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) { //console.log(value); alert(text);
        this.setState({
                    mvalue: {year: value, month: text}
                });
         //this.refs.pickAMonth.hide()
         this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }
    changeFileType(e){
        this.setState({
            fileType: e.target.value
        })
    }
    testApi(e){
        axios.get(config.get('API_URL')+'/tableau/test-api/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                tableau_username: "",
            }
        }).then(response => {
            console.log(response);


        }).catch(error => {
          console.log(error);
        });
    }
    render() { //console.log(this.state.mvalue);
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
            ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };

        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Upload Excel</h4>
                                    {/*<p className="category"></p>*/}

                                </div>
                                <hr className="m-0"/>
                                <div className="content">
                                    <form method="post" action="#" id="#">
                                        <div className="col-md-4  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">File Type</label>
                                                <select name="version" className="form-control" value={this.state.fileType} onChange={this.changeFileType.bind(this)}>
                                                    <option value="Base and EMI">Base and EMI</option>
                                                    <option value="Anycard deactivation">Anycard deactivation</option>
                                                    <option value="EMI Details">EMI Details</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Select Month</label>
                                                <Picker
                                                    ref="pickAMonth"
                                                    years={new Date().getFullYear()}
                                                    value={mvalue}
                                                    lang={pickerLang.months}
                                                    onChange={this.handleAMonthChange}
                                                    onDismiss={this.handleAMonthDissmis}

                                                >
                                                    <MonthBox value={makeText(mvalue)} onClick={this.handleClickMonthBox} />
                                                </Picker>
                                            </div>
                                        </div>
                                        <div className="col-md-4  col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Upload Your Excel FIle</label>
                                                <input type="file" name="file" className="form-control-file" onChange={this.onChangeHandler} />
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <button width="100%" type="button" className="btn btn-primary" onClick={this.fileUploadHandler} disabled={this.state.isSubmit}>Upload File</button>
                                                &nbsp; &nbsp;<button width="100%" type="button" className="btn btn-secondary" onClick={this.testApi.bind(this)} >Cancel</button>
                                                <div className='sweet-loading'>
                                                    <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={20}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/*<div className="col-md-3 pull-left">*/}
                                        {/*    */}
                                        {/*</div>*/}
                                        <div className="clearfix"></div>
                                    </form>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default UploadExcel